import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { ServerUrlService } from 'src/app/services/server-url.service'
import {
  LinkOAuthProviderResponse,
  OAuthProvidersResponse,
  UnlinkOAuthProviderResponse,
} from '../interfaces/login.interface'

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  constructor(
    private readonly httpClient: HttpClient,
    private readonly serverUrl: ServerUrlService
  ) {}

  login(login: string, password: string) {
    return this.httpClient.post(`${this.serverUrl.url}/auth/login`, {
      login,
      password,
    })
  }

  getOAuthProviders(): Observable<OAuthProvidersResponse> {
    return this.httpClient.get<OAuthProvidersResponse>(`${this.serverUrl.url}/auth/providers`)
  }

  initiateOAuthLogin(provider: string): void {
    // Pass client param so backend can include it in the callback redirect
    const client = this.serverUrl.getInfo('name')
    const clientParam = client ? `?client=${encodeURIComponent(client)}` : ''
    window.location.href = `${this.serverUrl.url}/auth/${provider}${clientParam}`
  }

  linkOAuthProvider(
    token: string,
    provider: string,
    providerId: string
  ): Observable<LinkOAuthProviderResponse> {
    return this.httpClient.post<LinkOAuthProviderResponse>(
      `${this.serverUrl.url}/auth/link-provider`,
      { provider, providerId },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
  }

  unlinkOAuthProvider(token: string, provider?: string): Observable<UnlinkOAuthProviderResponse> {
    const body = provider ? { provider } : {}
    return this.httpClient.post<UnlinkOAuthProviderResponse>(
      `${this.serverUrl.url}/auth/unlink-provider`,
      body,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
  }
}
